// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"AdditionalCoveragesPage_themeRoot__1EQZH","coverageFilter":"AdditionalCoveragesPage_coverageFilter__1tgox"};